/* eslint-disable max-classes-per-file */
const { Formatter, JsonRpcProvider } = require("@ethersproject/providers");
const { Logger } = require("@ethersproject/logger");

const logger = new Logger("1");

export class CustomFormatter extends Formatter {
    constructor() {
        super();
        logger.checkNew(new.target, Formatter);
        const customFormats = this.getDefaultFormats();
        customFormats.block.timestamp = this.bigNumber;
        this.formats = customFormats;
    }
}
export class CustomJsonRpcProvider extends JsonRpcProvider {
    formatter = new CustomFormatter();
}
